import { useState, useEffect, useCallback } from 'react'
import { debounce } from 'lodash'

const SCREEN_SIZE_CHECK_DEBOUNCE = 200

export function useIsMobile(breakpoint: number = 768): boolean {
  const [isMobile, setIsMobile] = useState(false)

  const checkScreenSize = useCallback(() => {
    setIsMobile(window.innerWidth < breakpoint)
  }, [breakpoint])

  useEffect(() => {
    const debouncedCheckScreenSize = debounce(
      checkScreenSize,
      SCREEN_SIZE_CHECK_DEBOUNCE,
    )
    debouncedCheckScreenSize()
    window.addEventListener('resize', debouncedCheckScreenSize)

    return () => {
      window.removeEventListener('resize', debouncedCheckScreenSize)
      debouncedCheckScreenSize.cancel() // Cancel any pending debounced calls
    }
  }, [checkScreenSize])

  return isMobile
}
